<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">
                  Devolucion #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{ 'badge-success': current.estado == 'A', 'badge-warning': current.estado == 'B', 'badge-danger': current.estado == '9' }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">{{ current.estado_str }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <div class="btn-group"></div>
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                >{{ current.errors.detail }}</small>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>NIT de Cliente</label>
                      <input
                        v-model="current.nit"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Nombre de Cliente</label>
                      <input
                        v-model="current.cliente"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Tienda</label>
                      <input
                        v-model="current.tienda"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label>Fecha</label>
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Vendedor</label>
                      <input
                        v-model="current.usuario"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>Caja</label>
                      <input
                        v-model="current.caja"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Total Cargo</label>
                      <input
                        v-model="current.valor_total"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Total Devuelto</label>
                      <input
                        v-model="current.valor_total_devuelto"
                        class="form-control"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.total"
                        class="form-text text-danger"
                      >{{ current.errors.total[0] }}</small>
                    </div>
                  </div>
                </div>
                <label>Detalle de la Devolucion</label>
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Descrición</th>
                        <th>SKU</th>
                        <th class="text-center">Precio</th>
                        <th class="text-center">Cantidad</th>
                        <th class="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detalle in current.detalle_cargo" v-bind:key="detalle.id">
                        <td>{{ detalle.cargo_d.descripcion }}</td>
                        <td>{{ detalle.cargo_d.producto }}</td>
                        <td>{{ detalle.cargo_d.precio }}</td>
                        <td>{{ detalle.cargo_d.cantidad_um }}</td>
                        <td>{{ detalle.cargo_d.total }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <router-link
                    class="btn btn-outline-info"
                    :to="{ name: 'inventario-devoluciones' }"
                  >
                    <i class="fa fa-arrow-left"></i>
                    Listado de Devoluciones
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        estado_str: "",
        total: "",
        cliente_nombre: "",
        cliente_nit: "",
        numero: "",
        errors: [],
        cxcabonod_set: [],
        cxcabonocontab_set: [],
        cxcaplicacionabonocargo_set: [],
      },

      productos: [],
      options: [],
      producto_lote: [],
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    refreshCurrent() {
      let self = this;
      DevolucionesService.getById(this.$route.params.id).then((response) => {
        self.current.id = response.data.id;
        self.current.nit = response.data.cliente;
        self.current.tienda = response.data.tienda.nombre;
        self.current.fecha = response.data.fecha;
        self.current.cliente =
          response.data.devolucionclienteecargoe_set[0].cargo_e.cliente_nombre;
        self.current.estado = response.data.estado;
        self.current.estado_str = response.data.estado_str;
        self.current.usuario = response.data.usuario.name;
        self.current.caja = response.data.caja.caja;
        self.current.valor_total =
          response.data.devolucionclienteecargoe_set[0].cargo_e.valor_total;
        self.current.valor_total_devuelto = response.data.valor_total_devuelto;
        self.current.detalle_cargo = response.data.devolucioncliented_set;
      });
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      self.current.cliente = self.current.cliente.nit;
      let current = Object.assign({}, self.current);
      DevolucionesService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "cxc-abonos-editar",
              params: { id: response.data.id },
            });
            document.location.reload();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },

    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DevolucionesService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
